var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "consent" },
    [
      _c("span", [
        _vm._v(
          'Durch Anklicken von "' +
            _vm._s(_vm.buttonName) +
            '" bestätigst du deine Eingabe und stimmst unseren '
        ),
      ]),
      _c("router-link", { attrs: { to: { name: "Datenschutz" } } }, [
        _vm._v("Datenschutzbestimmungen"),
      ]),
      _c("span", [_vm._v(" sowie ")]),
      _c("router-link", { attrs: { to: { name: "AGB" } } }, [_vm._v("AGB")]),
      _c("span", [
        _vm._v(
          " zu. Du bist damit einverstanden E-Mails von " +
            _vm._s(_vm.$store.state.brandName) +
            " zu erhalten, wenn du aktiver Kunde sind."
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }